export interface Tag {
  id: string
  text: string
}

export const generateTagId = (text: string) =>
  text.replace(/[^a-zA-Z]/g, "").toLowerCase()
